module.exports = __webpack_public_path__ + "img/Weapon_234.f0666898.png";